<template>
  <div class="engagement-summaryBlock">
    <mds-layout-grid>
      <mds-row>
        <mds-col
          v-if="leftToolSummary.length > 0"
          :cols="3"
          class="engagement-summaryBlockAlign"
        >
          <div
            class="engagement-summaryBlock-Single"
            :key="data.key"
            v-for="data in leftToolSummary"
          >
            <div class="label">
              {{ data.key }}
              <mce-legend
                hideTopBorder
                :horizontal="true"
                class="engagement-summaryBlockLegend"
              >
                <mce-legend-item
                  label=""
                  key-type="donut"
                  color="green"
                ></mce-legend-item>
              </mce-legend>
            </div>
            <div class="value">
              <mds-button
                type="button"
                variation="flat"
                icon-right="caret-down"
                @click="toggleNetCashflow = !toggleNetCashflow"
                id="summaryDetailsId"
                flatButtonIconSize="small"
                class="no-padding"
              >
                {{ data.value }}</mds-button
              >

              <mds-popover
                width="200px"
                v-if="toggleNetCashflow"
                triggered-by="summaryDetailsId"
                v-model="toggleNetCashflow"
                :position="['bottom-right']"
              >
                <p>Not for user.</p>
              </mds-popover>
            </div>
          </div>
        </mds-col>
        <mds-col :cols="9" :class="separatorClass">
          <div
            class="engagement-summaryBlock-Single"
            :key="data.key"
            v-for="data in rightToolSummary"
          >
            <div class="label">{{ data.key }}</div>
            <div class="value">
              <strong>{{ data.value }}</strong>
            </div>
          </div>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
  </div>
</template>
<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import { MceLegend, MceLegendItem } from "@mce/legend";
import { MdsButton } from "@mds/button";
import MdsPopover from "@mds/popover";

export default {
  props: {
    leftToolSummary: {
      type: Array,
    },
    rightToolSummary: {
      type: Array,
    },
  },
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MceLegend,
    MceLegendItem,
    MdsPopover,
    // MdsListGroup,
    // MdsListGroupItem,
    MdsButton,
  },
  computed: {
    separatorClass() {
      if (this.leftToolSummary.length > 0)
        return "engagement-summaryBlockSeparator";
      else return "engagement-summaryBlockWithOutSeparator";
    },
  },
  data() {
    return {
      toggleNetCashflow: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.right-body-container {
  .engagement-summaryBlock {
    background-color: $mds-background-color-light-gray;
    padding: $mds-space-1-x $mds-space-3-x;
    margin-top: $mds-space-4-x;
    .engagement-summaryBlockAlign {
      padding-top: 5px;
    }
    .engagement-summaryBlockSeparator {
      border-left: $mds-border-separator-on-light;
      @include v-center-space-around;
      padding-bottom: $mds-space-2-x;
      padding-top: $mds-space-half-x;
    }
    .engagement-summaryBlockWithOutSeparator {
      @include v-center-space-around;
      padding-bottom: $mds-space-2-x;
      padding-top: $mds-space-half-x;
    }
    .engagement-summaryBlockLegend {
      display: inline;
      @include no-padding();
      margin-left: $mds-space-half-x;
    }
    .engagement-summaryBlock-Single {
      @include mds-body-text-m();
    }
    .no-padding {
      @include no-padding();
    }
  }
}
</style>
